import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const villains = [{
  title: 'Pastillas Azules',
  desc: 'Solo ponen un parche temporal, dañan tu corazón a largo plazo y te hacen dependiente. No arreglan la causa raíz del problema.'
}, {
  title: 'Mitos de la Edad',
  desc: "Te dicen que 'es normal por la edad'. Mentira. Hay hombres de 60 años con mejor rendimiento que jóvenes de 30. Es biología, no cronología."
}, {
  title: 'Consejos Genéricos',
  desc: "'Relájate y ya'. El peor consejo posible cuando tu sistema nervioso está secuestrado por la ansiedad de rendimiento."
}];
export function VillainSection() {
  return <section className="py-24 bg-brand-darker relative border-y border-brand-cardBorder" data-id="element-275">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-276">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-277">
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-white mb-6" data-id="element-278">
            La industria{' '}
            <span className="text-brand-crimson" data-id="element-279">te ha mentido.</span>
          </h2>
          <p className="text-lg text-brand-text/80 max-w-3xl mx-auto leading-relaxed" data-id="element-280">
            Te venden pastillas azules que solo ponen un parche temporal, pero
            que dañan tu corazón y no arreglan la causa raíz. O te dicen que "es
            la edad". <strong className="text-white" data-id="element-281">Mentira.</strong>
          </p>
          <p className="text-lg text-brand-text/80 max-w-3xl mx-auto mt-4 leading-relaxed" data-id="element-282">
            Tu cuerpo es una máquina biológica perfecta. Si está fallando, es
            porque tus niveles de Óxido Nítrico están bajos, tu testosterona
            está secuestrada por el estrés y tus arterias han perdido
            elasticidad debido a la vida moderna.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-283">
          {villains.map((villain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="bg-brand-card border border-brand-cardBorder p-8 rounded-xl relative group hover:border-brand-crimson/50 transition-colors" data-id="element-284">
              <div className="absolute top-0 left-0 w-full h-1 bg-brand-crimson/20 rounded-t-xl group-hover:bg-brand-crimson transition-colors" data-id="element-285"></div>
              <XCircle className="w-10 h-10 text-brand-crimson mb-6" data-id="element-286" />
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-287">
                {villain.title}
              </h3>
              <p className="text-brand-muted leading-relaxed" data-id="element-288">{villain.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}